import React, { Component } from "react";
import Header from './Header'
import {getTower, getPolicyPDF, getTowerPDF, deleteTower} from '../services/BinderDropService';

import Logo_DragDrop from "../img/ico/black_dragdrop.png"
import Logo_Check from "../img/ico/color_checkbox.png"
import Logo_RoundCheck from "../img/ico/round_check.png"
import Tower from "../components/Tower";
import PolicyDetailsPopup from "../popups/PolicyDetailsPopup";
import TowerDetailsPopup from "../popups/TowerDetailsPopup";
import moment from "moment";
import InfoCard from "../components/InfoCard";

const queryString = require('query-string');



class TowerAddUpdate extends Component {
  constructor(props) {
    super(props);

    const _params = queryString.parse(this.props.location.search);

    this.state = {
      tower: {policies:[]},
      towerID: _params.id,
      inDropZone:false,
      showPolicyPopup:false,
      showTowerPopup:false,
      loading:false,
      newPolicyData:{},
      newTowerData:{},
      pdf:{},
    };

    //document.title = "Home"
  }

  componentDidMount() {
    
    if(this.state.towerID){
      this.getTower()
    }
    
  }


  getTower = () =>{
    getTower(this.state.towerID).then((tower) => {
      this.setState({tower});
    });
  }

  deleteTower = () =>{
    deleteTower(this.state.tower).then((tower) => {
      window.location.href = window.location.origin;
    });
  }

  handleDragLeave = (e) =>{
    /*
    e.stopPropogation()*/
    e.preventDefault()
    console.log("LEFT")
    this.setState({inDropZone:false})
    // Bring the endzone back to normal, maybe?
  };

  handleDragEnter = (e) =>{
    /*
    e.stopPropogation()*/
    e.preventDefault()
    
    console.log("ENTERED")

    this.setState({inDropZone:true})
  };
  handleDragOver = (e) =>{
    /*
    e.stopPropogation()*/
    e.preventDefault()
    this.setState({inDropZone:true})
  };

  handleDrop = (e) =>{
    /*
    e.stopPropogation()*/
    e.preventDefault()
    
    if(this.state.inDropZone){
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        
        var validFiles = true;

        console.log(e.dataTransfer.files);
        Array.from(e.dataTransfer.files).forEach(f => { 
          if(f.type !== "application/pdf") validFiles = false;
        });

        if(validFiles){
          this.setState({showTowerPopup:true,loading:true});
          Array.from(e.dataTransfer.files).forEach(f => { 
            console.log(URL.createObjectURL(f));
            const reader = new FileReader();
            
            reader.onloadend = () => {
              
              const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");

              this.setState({pdf:{src:URL.createObjectURL(f), base64String, name:f.name}}, () =>{
                if(!this.state.towerID){ 
                  getTowerPDF(this.state.pdf.base64String).then((resp) => {
                    this.setState({newTowerData:resp, loading:false})
                  });
                }
                else{
                  this.getPolicyPDF();
                }
              });

              

            };
            reader.readAsDataURL(f);
          });
        }
        else{
          
        }
        
        e.dataTransfer.clearData()
      }

      
    }

    this.setState({inDropZone:false});
  };

  getPolicyPDF = () => {
    this.setState({showPolicyPopup:this.state.towerID ? true : false, showTowerPopup:this.state.towerID ? false : true, loading:true});
    getPolicyPDF(this.state.pdf.base64String).then((resp) => {
      if(resp){
        this.setState({newPolicyData:resp, loading:false})
      }
      else{
        this.setState({loading:false});
      }
    });
  }
  
  towerPopupClose = (tower) => {
    console.log("SAVE", tower);
    this.setState({showTowerPopup:false});
    if(tower){
      this.setState({tower, towerID:tower.towerId});
      this.getPolicyPDF();
    }
  }

  policyPopupClose = (success) =>{
    this.setState({showPolicyPopup:false});
    if(success){
      this.getTower();
      this.setState({pdf:{}, newPolicyData:{}})
    }
    else{
      this.setState({pdf:{}, newPolicyData:{}})
    }
  }


  manuallyAdd = () =>{
    this.setState({showPolicyPopup:this.state.towerID ? true : false, showTowerPopup:this.state.towerID ? false : true});
  }
  

  render() {

    var _ui = { title:"Add New Tower", actionBoldText:"Drop Primary Binder PDF Here", actionText:"to start new tower."};
    if(this.state.towerID){
      _ui = { title:"Update Tower", actionBoldText:"Drop Binder PDF Here",  actionText:"to add binder."};
    }

    return (
      <div>
        <Header title={_ui.title}/>
        {this.state.towerID &&
        <a className="pillButton headerButton" onClick={this.deleteTower}>Delete Tower</a>
        }
        <PolicyDetailsPopup tower={this.state.tower} towerID={this.state.towerID} pdf={this.state.pdf} loading={this.state.loading} policy={this.state.newPolicyData} open={this.state.showPolicyPopup} onClose={this.policyPopupClose}/>
        <TowerDetailsPopup pdf={this.state.pdf} loading={this.state.loading} tower={this.state.newTowerData} open={this.state.showTowerPopup} onClose={this.towerPopupClose}/>
        {this.state.towerID &&
        <div className="cardRow">
          <InfoCard title="Company" value={this.state.tower.company?.name}/>
          <InfoCard title="Policy Period" value={moment(this.state.tower.effectiveDate).format('MMM YY')+" - "+moment(this.state.tower.expirationDate).format('MMM YY')}/>
        </div>
        }
         <div className="cardRow" onClick={this.manuallyAdd}>
            <div draggable="true" className={this.state.inDropZone ? "card binderCard active" : "card binderCard"} onDragEnter={this.handleDragEnter} onDragOver={this.handleDragOver} onDragLeave={this.handleDragLeave} onDrop={this.handleDrop}>
              <img src={this.state.inDropZone ? Logo_Check : Logo_DragDrop}/>
              <span><a>{_ui.actionBoldText}</a> {_ui.actionText}</span>
              <button className="pillButton" onClick={this.manuallyAdd}>or Manually Add</button>
            </div>
        </div>

        {this.state.towerID && this.state.tower.policies?.length > 0 &&
          <Tower editing refreshTower={this.getTower} tower={this.state.tower}/>
        }
       
      </div>
    );
  }
}
 
export default TowerAddUpdate;